import React, { useEffect, useState } from 'react'
import './MainBody.css'
import About_Me_Cards from './About_Me_Cards'
import StatCards from './AboutMECards'
import SkillCards from './SkillCards'
import MissionCards from './MissionCards'
import ProjectCards from './projectcards'
import { Link } from 'react-router-dom'
import video1 from '../jpegs/Recording 2026-08-17 001526.mp4'
import video2 from '../jpegs/WhatsApp Video 2026-08-12 at 9.47.46 PM.mp4'
import video3 from '../jpegs/Recording 2026-08-17 012817.mp4'
import my_img from '../jpegs/images.jpg'

const roles = [
  'Frontend Developer',
  'UI Engineer',
  'Creative Coder',
  'Problem Solver',
  'IoT developer'
]

const MainBody = () => {

  const [typedText, setTypedText] = useState('')

  useEffect(() => {
    let roleIdx = 0
    let charIdx = 0
    let deleting = false
    let timeoutId

    const type = () => {
      const word = roles[roleIdx]

      if (!deleting) {
        charIdx++
        setTypedText(word.slice(0, charIdx))

        if (charIdx === word.length) {
          deleting = true
          timeoutId = setTimeout(type, 1400)
          return
        }
      } else {
        charIdx--
        setTypedText(word.slice(0, charIdx))

        if (charIdx === 0) {
          deleting = false
          roleIdx = (roleIdx + 1) % roles.length
        }
      }

      timeoutId = setTimeout(type, deleting ? 40 : 80)
    }

    type()

    return () => clearTimeout(timeoutId)
  }, [])

 

  return (
    <>
      {/* -----------------------------------------mainbody section start name etc------------------------------------------------------------------------ */}
      <div className="h1">
        <div className="d2">
          <hr />
          <h3>AVAILABLE FOR WORK . BASED ANYWHERE</h3>
        </div>

        <div className="name">
          ABDULSAMAD KAMRAN
        </div>

        <div className="easykaam">
          {typedText}
        </div>
        <p className="hero-desc">
          I design and build things for the web — from interfaces that feel alive to systems that quietly work.
        </p>
        <div className="hero-cta">
          <Link to="/project" className="btn btn-primary">View Work →</Link>
          <Link to="/contact" className="btn btn-ghost">Get in Touch</Link>
        </div>
        <div className="scroll-cue">
          <div className="scroll-line"></div>
          SCROLL

        </div>
      </div>
      {/* ---------------------------------------------about me section------------------------------------------------------------------------- */}
     <div className="about-card">
  <div className="avatar-circAe"><About_Me_Cards/></div>
      <div className='about-me-txt'>
        <p> Hey I'm Abdulsamad, a developer focused on building fast, thoughtful, and slightly futuristic digital experiences. I care about the details most people scroll past — the easing curve, the loading state, the empty screen that actually says something.
          <br />
          Outside of client work, I spend time exploring new frameworks, reading about design systems, and tinkering with side projects that rarely ship but always teach me something.</p>
        <br />
        <div className='stats-row'>
          <StatCards quantity="2+" title="Experience"/>
          <StatCards quantity="10+" title="Projects Delivered"/>
          <StatCards quantity="10+" title="Happy Clients"/>
          
        </div>
        </div>
      </div>
      {/* ----------------------------------mission sections-------------------------------------------------------------------------------- */}
      <div className="missionMain">
        <div className="section-tag">
          <hr />
          <span>.mission</span>
        </div>
        <h4>What Drives Me</h4>

        <div className="mission-grid">
          <MissionCards number="01" title="— Responsive Design" desc="Websites that look great and work smoothly on phones, tablets, and desktops." />
          <MissionCards number="02" title="— User Friendly" desc="Simple, intuitive interfaces that make it easy for anyone to navigate and use." />
          <MissionCards number="03" title="— Clean & Maintainable Code" desc="Well-structured code that's easier to unders" />
          <MissionCards number="04" title="— Fast Performance" desc="Lightweight and optimized websites that load quickly and feel smooth." />
          <MissionCards number="05" title="— Interactive Experiences" desc="Engaging animations and interactions that make websites feel modern and alive." />
          <MissionCards number="06" title="— Keep Learning" desc="Always exploring new technologies and better ways to build for the web." />
          <MissionCards number="07" title="— Hosting/Accessible by Everyone" desc="Building websites that are easy to use and accessible to a wider range of people." />
          <MissionCards number="08" title="— Scalable Solutions" desc="Creating websites with a solid foundation that can grow with new features and users." />
        
        </div>
      </div>
      {/* -------------------------------------------skills portion ---------------------------------------------------------------------------- */}
      <div className='skillsMain'>
        <div className='section-tag'>
          <hr />
          <span>.skills</span>
        </div>
        <h4>What I work with</h4>
        <div className="skills-grid">
          <SkillCards name="HTML" pct={90} category="FRONTEND" />
          <SkillCards name="CSS" pct={85} category="FRONTEND" />
          <SkillCards name="Java Script" pct={80} category="FRONTEND/BACKEND" />
          <SkillCards name="Node.js" pct={80} category="BACKEND" />
          <SkillCards name="Express.js" pct={75} category="BACKEND" />
          <SkillCards name="MongoDB/SQL" pct={70} category="BACKEND" />
          <SkillCards name="React/NextJs" pct={98} category="FRONTEND" />
          <SkillCards name="vite" pct={85} category="FRONTEND" />
          <SkillCards name="WordPress" pct={90} category="BACKEND" />
          <SkillCards name="ESP8266" pct={98} category="Sever Communication" />
          <SkillCards name="STM32F407" pct={80} category="IoT devices" />
        </div>
      </div>
      {/*----------------------------------------------------------projects sections--------------------------------------------  */}
      <div className='projects-main'>
        <div className='project-tag'>
          <hr />
          <span>.Projects</span>
        </div>
        <div className='project-txt'>
          <h4>Selected Work</h4>
        </div>
        <div className='project_cards'>
          <ProjectCards
  thumbLabel="PROJECT_01.PREVIEW"
  video={video1}
  title="Mouse Counter Website Dashboard"
  desc="A simple tool that tracks mouse clicks in real time."
  tags={['HTML', 'CSS', 'JavaScript','Expressjs','MongoDb']}
  link="https://forestgreen-mole-818716.hostingersite.com/"
/>
          <ProjectCards
            thumbLabel="PROJECT_01.PREVIEW"
            video={video2}
            title="IoT Device"
            desc="A simple tool that tracks mouse clicks in real time."
            tags={['HTML', 'CSS', 'JavaScript','Expressjs','MongoDb','esp8266,STM32']}
            link="https://forestgreen-mole-818716.hostingersite.com/"
          />
          <ProjectCards
            thumbLabel="PROJECT_01.PREVIEW"
            video={video3}
            title="My Portfolio"
            desc="A simple tool that tracks mouse clicks in real time."
            tags={['HTML', 'CSS', 'JavaScript']}
            link="https://forestgreen-mole-818716.hostingersite.com/"
          />
         
        </div>
      </div>
      {/* --------------------------------------------contact me section--------------------------------------------------------------------- */}
      <div className='contactme-main'>
        <div className='contact-tag'>
          <span>.contact</span>
          <hr />
        </div>
        <div className='contact-txt'>
          <h4>Let's build something together</h4>
          <h2>Have a project in mind or just want to say hi? My inbox is open.</h2>
        </div>
        <Link to="/contact" > <button className='contact-me-btn'>Say Hello</button></Link>
        <div className="links">
  <a
    href="https://www.instagram.com/"
    target="_blank"
    rel="noreferrer"
    aria-label="Instagram"
  >
    Instagram
  </a>

  <a
    href="https://x.com/"
    target="_blank"
    rel="noreferrer"
    aria-label="X"
  >
    X
  </a>

  <a
    href="https://www.linkedin.com/"
    target="_blank"
    rel="noreferrer"
    aria-label="LinkedIn"
  >
    LinkedIn
  </a>
</div>
</div>
    </>
  )
}
export default MainBody